<template>
  <div class="card--project-image">
    <a
      :href="linkDetail"
      target="_blank"
      style="text-decoration: none"
      v-if="useExternalLink && !useMultiImage"
    >
      <picture>
        <source :srcset="photoUrl" type="image/webp" />
        <source :srcset="getFallbackImage(photoUrl)" type="image/jpeg" />
        <img :src="getFallbackImage(photoUrl)" class="project--image" :alt="newImageAlt" />
      </picture>
    </a>
    <router-link
      :to="linkDetail"
      style="text-decoration: none"
      v-else-if="useRouterLink && !useMultiImage"
    >
      <picture>
        <source :srcset="photoUrl" type="image/webp" />
        <source :srcset="getFallbackImage(photoUrl)" type="image/jpeg" />
        <img :src="getFallbackImage(photoUrl)" class="project--image" :alt="newImageAlt" />
      </picture>
    </router-link>
    <div v-else-if="!useRouterLink">
      <picture>
        <source :srcset="photoUrl" type="image/webp" />
        <source :srcset="getFallbackImage(photoUrl)" type="image/jpeg" />
        <img :src="getFallbackImage(photoUrl)" class="project--image" :alt="newImageAlt" />
      </picture>
    </div>
    <v-carousel class="carousel--wrapper" v-else>
      <v-carousel-item v-for="(photo, index) in photos" :key="index" class="carousel--slide">
        <a :href="linkDetail" target="_blank" style="text-decoration: none" v-if="useExternalLink">
          <picture>
            <source :srcset="photo.url" type="image/webp" />
            <source :srcset="getFallbackImage(photo.url)" type="image/jpeg" />
            <img :src="getFallbackImage(photo.url)" class="project--image" :alt="newImageAlt" />
          </picture>
        </a>
        <router-link :to="linkDetail" style="text-decoration: none" v-else>
          <picture>
            <source :srcset="photo.url" type="image/webp" />
            <source :srcset="getFallbackImage(photo.url)" type="image/jpeg" />
            <img :src="getFallbackImage(photo.url)" class="project--image" :alt="newImageAlt" />
          </picture>
        </router-link>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
import HelperMixin from '@/mixins/helpers';

export default {
  mixins: [HelperMixin],
  props: {
    linkDetail: {
      default: '/',
      require: true,
    },
    primaryPhoto: {
      default: null,
      require: true,
    },
    photos: {
      default: null,
      require: true,
    },
    allowMultiImage: {
      default: false,
    },
    useRouterLink: {
      default: true,
    },
    useExternalLink: {
      default: false,
    },
    imageAlt: {
      default: null,
      require: true,
    },
  },
  data: () => ({}),
  computed: {
    useMultiImage() {
      return this.photos && this.photos.length > 1 && this.allowMultiImage;
    },
    newImageAlt() {
      return this.imageAlt + ' - BeliRumah';
    },
    photoUrl() {
      return this.primaryPhoto ? this.primaryPhoto.url : '';
    },
  },
  methods: {},
};
</script>
